import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { State as CoreState } from '@emm/core/store/core.reducer';
import {AuthenticationStatus} from '@emm/core/models/enums';
import {CoreStoreService} from '@emm/core/store/core-store.service';
import {AuthActions} from '@emm/auth/store/auth.actions';
import {AuthSelectors} from '@emm/auth/store/auth.selectors';
import { User } from '@emm/core/models/user.model';


export interface AuthQueries {
    isAuthenticated$: Observable<boolean>;
    isReadOnly$: Observable<boolean>;
    status$: Observable<AuthenticationStatus>;
    user$: Observable<User>;
    userName$: Observable<string>;
}

@Injectable({
    providedIn: 'root',
})
export class AuthStoreService extends CoreStoreService {

    dispatch = {
        authenticateUser: () => this.store.dispatch(AuthActions.authenticateUser()),
        signOut: () => this.store.dispatch(AuthActions.signOut())
    };

    queries: AuthQueries = {
        user$: this.select(AuthSelectors.getUser),
        status$: this.select(AuthSelectors.getStatus),
        isAuthenticated$: this.select(AuthSelectors.getAuthenticated),
        isReadOnly$: this.select(AuthSelectors.getIsReadonly),
        userName$: this.select(AuthSelectors.getUserName)
    };

    constructor(store: Store<CoreState>) {
        super(store);
    }

}
